window.addEventListener('DOMContentLoaded', function() {
  let apiRecommendations = document.querySelector(".product-recommendations--api");

  if (apiRecommendations) {
    const checkExist = setInterval(function() {
      const element = document.querySelector('quick-add');
      
      if (element) {
        class QuickAdd extends HTMLElement {
          constructor() {
            super();
            this.addButton = this.querySelector('button');
            this.selectError = this.querySelector(".product-card--error");
            this.soldOutError = this.querySelector(".product-card--soldout");
            this.variants = this.querySelectorAll('.product-card--variant__input');
            this.addEventListener("click", this.QuickAddClick);
          }
        
          QuickAddClick = (evt) => {
            if (evt.target.tagName == "BUTTON") {
              evt.preventDefault();
              let value = "selectError";
              if (evt.target.dataset.id) value = evt.target.dataset.id;
              this.addVariantToCart(value);
            } else if (evt.target.tagName == "INPUT" && !evt.target.disabled) {
              this.selectError?.classList.add("hidden");
              this.soldOutError?.classList.add("hidden");
              if (this.addButton) this.addButton.dataset.id = evt.target.value;
            }
          }
        
          addVariantToCart = (id) => {
            if (!id || id == "selectError") {
              this.selectError?.classList.remove("hidden");
              return;
            }
          
            const form_data = { quantity: 1, id: id };
          
            $.ajax({
              method: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: form_data,
            }).done((product) => {
              if (product.quantity_available <= 0) {
                this.soldOutError?.classList.remove("hidden");
                return;
              }

              if (!sessionStorage.getItem("drawer_cart_opened")) {
                document.querySelector('cart-drawer').open('openCookie');
              } else {
                if ($(window).width() >= 200) {
                  Cart.popover.show(product);
                }
              }
          
              var item_vr = '';
              var item_color = '';
              if (product.options_with_values.length > 0) {
                product.options_with_values.forEach(function (e) {
                  if (e.name == 'Color' || e.name == 'color') {
                    item_color = e.value;
                  }
                  if (e.name == 'Talla' || e.name == 'talla') {
                    item_vr = e.value
                  };
                })
              }
              dataLayer.push({ ecommerce: null });
              dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                  items: [{
                    item_name: product.title,
                    item_id: product.id,
                    item_color: item_color,
                    item_variant: item_vr,
                    item_category: product.type,
                    price: product.price,
                    item_brand: product.vendor,
                    index: 1,
                    quantity: 1
                  }]
                }
              })
          
              Cart.getCart(Cart.buildCart);
          
            }).fail((jqXHR) => {
              this.soldOutError?.classList.remove("hidden");
            });
          }
        }
        
        customElements.define('quick-add', QuickAdd);
        // El elemento se ha creado dinámicamente
        clearInterval(checkExist);
      }
    }, 1000);
  } else {
    class QuickAdd extends HTMLElement {
      constructor() {
        super();
        this.addButton = this.querySelector('button');
        this.selectError = this.querySelector(".product-card--error");
        this.soldOutError = this.querySelector(".product-card--soldout");
        this.variants = this.querySelectorAll('.product-card--variant__input');
        this.addEventListener("click", this.QuickAddClick);
      }
    
      QuickAddClick = (evt) => {
        if (evt.target.tagName == "BUTTON") {
          evt.preventDefault();
          let value = "selectError";
          if (evt.target.dataset.id) value = evt.target.dataset.id;
          this.addVariantToCart(value);
        } else if (evt.target.tagName == "INPUT" && !evt.target.disabled) {
          this.selectError?.classList.add("hidden");
          this.soldOutError?.classList.add("hidden");
          if (this.addButton) this.addButton.dataset.id = evt.target.value;
        }
      }
    
      addVariantToCart = (id) => {
        if (!id || id == "selectError") {
          this.selectError?.classList.remove("hidden");
          return;
        }
      
        const form_data = { quantity: 1, id: id };
      
        $.ajax({
          method: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: form_data,
        }).done((product) => {
          if (product.quantity_available <= 0) {
            this.soldOutError?.classList.remove("hidden");
            return;
          }

          if (this.classList.contains('add-cart-item')) {
            document.querySelector('cart-drawer').open();
          }
              
          if (!sessionStorage.getItem("drawer_cart_opened")) {
            document.querySelector('cart-drawer').open('openCookie');
          } else {
            if ($(window).width() >= 200) {
              Cart.popover.show(product);
            }
          }

          var item_vr = '';
          var item_color = '';
          if (product.options_with_values.length > 0) {
            product.options_with_values.forEach(function (e) {
              if (e.name == 'Color' || e.name == 'color') {
                item_color = e.value;
              }
              if (e.name == 'Talla' || e.name == 'talla') {
                item_vr = e.value
              };
            })
          }
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              items: [{
                item_name: product.title,
                item_id: product.id,
                item_color: item_color,
                item_variant: item_vr,
                item_category: product.type,
                price: product.price,
                item_brand: product.vendor,
                index: 1,
                quantity: 1
              }]
            }
          })
      
          Cart.getCart(Cart.buildCart);
      
        }).fail((jqXHR) => {
          this.soldOutError?.classList.remove("hidden");
        });
      }
    }
    
    customElements.define('quick-add', QuickAdd);
  }
})